'use client';
import { SafeHTML } from '@/shared/ui/SafeHTML';
import { ICollapsingData } from './interfaces';

export const CollapsingData = ({ text, type }: ICollapsingData) => {
  const formattedText = (text: ICollapsingData['text']) => {
    if (typeof text === 'string') {
      return text;
    }
    if (Array.isArray(text)) {
      return text.join(' ');
    }
    return '';
  };

  switch (type) {
    case 'html':
      return (
        <div className={'feature__text'}>
          <SafeHTML html={formattedText(text)} />
        </div>
      );

    case 'array':
      if (Array.isArray(text)) {
        return text.map((i: string, index: number) => (
          <p className={'collapsing__text collapsing__text_dots list'} key={index}>
            {i}
          </p>
        ));
      }

    default:
      return <p className={'collapsing__text collapsing__text_string'}>{text}</p>;
  }
};
